(function () {
  var CATEGORY_PARAM = 'filter.p.m.custom.category';
  var BRAND_PARAM = 'filter.p.m.custom.brand';

  // Move [data-hierarchy-child] INSIDE the category filter element so:
  //  - <details> (accordion): brand filter hides when category accordion collapses
  //  - <div>     (static)   : brand filter stays as immediate sibling (never collapses)
  //
  // For <details>: renderFilters only replaces "summary + *" (the content div),
  // so the appended hierarchy child is never overwritten by AJAX re-renders.
  function repositionBrandFilter() {
    document.querySelectorAll('[data-hierarchy-parent]').forEach(function (parent) {
      var form = parent.closest('form');
      if (!form) return;
      var child = form.querySelector('[data-hierarchy-child]');
      if (!child) return;

      if (parent.tagName === 'DETAILS') {
        // Append as last child of <details> — appears below category checkboxes,
        // inside the open accordion, invisible when the accordion is collapsed.
        if (child.parentNode !== parent) {
          parent.appendChild(child);
        }
      } else {
        // Static filter (no accordion): keep as immediate sibling after the category div.
        if (parent.nextElementSibling !== child) {
          parent.parentNode.insertBefore(child, parent.nextSibling);
        }
      }
    });
  }

  // Show/hide brand filter wrapper based on active category URL param.
  function updateHierarchyVisibility() {
    var url = new URL(window.location.href);
    var active = url.searchParams.has(CATEGORY_PARAM);
    document.querySelectorAll('[data-hierarchy-child]').forEach(function (el) {
      el.classList.toggle('facet-hierarchy-child--active', active);
    });
  }

  // Shopify marks category options disabled (count=0) when a brand is also active.
  // Remove that so categories stay clickable even while a brand is selected.
  function enableCategoryFilters() {
    document.querySelectorAll('[data-hierarchy-parent] input[type="checkbox"][disabled]').forEach(function (cb) {
      cb.removeAttribute('disabled');
    });
  }

  // Shopify intersects counts (category ∩ brand), making sibling categories show 0 when a brand
  // is selected. Save counts before brand selection and restore them after re-render.
  var savedParentCounts = {};

  function captureParentCounts() {
    var counts = {};
    document.querySelectorAll('[data-hierarchy-parent] li').forEach(function (li) {
      var cb = li.querySelector('input[type="checkbox"]');
      var countSpan = li.querySelector('.text-sm');
      if (cb && countSpan) {
        counts[cb.value] = countSpan.textContent.trim();
      }
    });
    if (Object.keys(counts).length > 0) {
      savedParentCounts = counts;
    }
  }

  function restoreParentCounts() {
    if (Object.keys(savedParentCounts).length === 0) return;
    document.querySelectorAll('[data-hierarchy-parent] li').forEach(function (li) {
      var cb = li.querySelector('input[type="checkbox"]');
      var countSpan = li.querySelector('.text-sm');
      if (cb && savedParentCounts[cb.value] && countSpan) {
        countSpan.textContent = savedParentCounts[cb.value];
      }
    });
  }

  // Capture phase: save parent counts just before a brand checkbox triggers a re-render
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches) return;
    if (input.matches('input[name="' + BRAND_PARAM + '"]')) {
      captureParentCounts();
    }
  }, true);

  // Category: single-select + always clear brand.
  // Capture phase ensures brand checkboxes are cleared BEFORE FacetForm.buildUrl reads the form.
  function handleCategoryChange(event) {
    var input = event.target;
    if (!input.matches || !input.matches('input[name="' + CATEGORY_PARAM + '"]')) return;

    if (input.checked) {
      document.querySelectorAll('input[name="' + CATEGORY_PARAM + '"]').forEach(function (cb) {
        if (cb !== input) cb.checked = false;
      });
    }

    document.querySelectorAll('input[name="' + BRAND_PARAM + '"]').forEach(function (cb) {
      cb.checked = false;
    });
  }

  document.addEventListener('change', handleCategoryChange, true);

  document.addEventListener('collection:rerendered', function () {
    repositionBrandFilter();
    updateHierarchyVisibility();
    enableCategoryFilters();

    var url = new URL(window.location.href);
    if (url.searchParams.has(BRAND_PARAM)) {
      restoreParentCounts();
    } else {
      captureParentCounts();
    }
  });

  captureParentCounts();
  repositionBrandFilter();
  updateHierarchyVisibility();
  enableCategoryFilters();
})();
